import { Alert, Card, Radio, Typography } from 'antd';
import { useAllCollectionSpotsFromGuide } from 'api/collection-spots.api';
import CollectionTypeSelector from 'components/CollectionTypeSelector';
import Loading from 'components/Loading';
import React, { Suspense, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentGuide } from 'store/guide-editor/selectors';
import useAllPublicStepSpots from 'utils/use-all-public-step-spots';

import { MapSpotFilterTypes } from 'constants/collection-map';
import './style.css';

const CMSMap = React.lazy(() => import('components/CMSMap/CMSMap'));
const { Title } = Typography;

/**
 *
 * @param {Id} collectionId
 * @param {Id} [filterCollectionId]
 */
const filterByCollection = (collectionId, filterCollectionId) =>
    !filterCollectionId || collectionId === filterCollectionId;

function GuideEditorMap() {
    const guide = useSelector(getCurrentGuide);
    /** @type {[MapSpotFilterType, React.Dispatch<React.SetStateAction<MapSpotFilterType>>]} */
    const [typeFilter, setTypeFilter] = useState(null);
    /** @type {[Id | undefined, React.Dispatch<React.SetStateAction<Id | undefined>>]} */
    const [collectionFilter, setCollectionFilter] = useState();
    const { spots = [] } = useAllCollectionSpotsFromGuide(guide?.id);
    const { stepSpots = [] } = useAllPublicStepSpots(guide?.id, false);
    const viewportArea = guide?.viewport_area;
    const searchArea = guide?.search_area;

    if (!guide) {
        return null;
    }

    const collectionSpots =
        typeFilter !== MapSpotFilterTypes.TIPS
            ? spots.filter(({ collection }) =>
                  filterByCollection(
                      collection.collection_type_id,
                      collectionFilter,
                  ),
              )
            : [];
    const tipSpots =
        typeFilter !== MapSpotFilterTypes.SPOTS
            ? stepSpots.filter(([_, steps]) =>
                  filterByCollection(steps[0].spot.id, collectionFilter),
              )
            : [];

    const noBBMessage =
        "Guide still doesn't have a bounding box for the map. Please reselect the location to automatically generate it.";

    return (
        <>
            <div className="guide-editor-map__title">
                <Title level={4}>Map</Title>
                <div className="guide-editor-map__filter">
                    <Radio.Group
                        defaultValue={typeFilter}
                        buttonStyle="solid"
                        onChange={(e) => setTypeFilter(e.target.value)}
                    >
                        <Radio.Button value={null}>All</Radio.Button>
                        <Radio.Button value={MapSpotFilterTypes.SPOTS}>
                            Spots
                        </Radio.Button>
                        <Radio.Button value={MapSpotFilterTypes.TIPS}>
                            Tips
                        </Radio.Button>
                    </Radio.Group>
                    <div className="guide-editor-map__collection-filter">
                        <CollectionTypeSelector
                            value={collectionFilter}
                            onChange={(newTypeId) => {
                                setCollectionFilter(newTypeId);
                            }}
                            placeholder="Filter by collection type"
                            size="middle"
                            allowClear
                        ></CollectionTypeSelector>
                    </div>
                </div>
            </div>
            {viewportArea || searchArea ? (
                <div className="guide-editor-map__map-container">
                    <Suspense fallback={<Loading />}>
                        <CMSMap
                            isEditingArea={null}
                            highlightedAreaOfInterest={viewportArea}
                            highlightedSearchArea={searchArea}
                            onAreaChanged={() => undefined}
                            collectionSpots={collectionSpots}
                            tipSpots={tipSpots}
                        />
                    </Suspense>
                    <div className="guide-editor-map__actions" />
                </div>
            ) : (
                <Card>
                    <Alert message={noBBMessage} showIcon type="warning" />
                </Card>
            )}
        </>
    );
}

export default GuideEditorMap;
